<div class="pag-container">

  <!-- breadcrumbs -->
  <app-campaign-3-breadcrumb #breadcrumbComponent *ngIf="showBreadCrumb"
    [arrayBreadcrumbs]="breadcrumbs"
    (onClickBreadcrumb)="breadcrumbClicked($event)"
    homeLink="">
  </app-campaign-3-breadcrumb>

  <!-- buttons -->
  <div class="ui-g-12 vertical-margin-20"  >
    <div class="ui-g-6 no-lateral-padding">
      <h1 class="title">{{ 'challenge.levelCreation' | translate }}</h1>
    </div>

    <div class="ui-g-6 d-flex justify-content-end">
      <button class="btn-page-act" style="margin-right: 10px;" data-testid="backToChallenge"
        (click)="onBackAction()">
        <i class="pi pi-arrow-left margin-fit"></i>
        <span>{{ 'challenge.back' | translate }}</span>
      </button>

      <button class="btn-page-act" *ngIf="!readOnly" (click)="onSaveLevel()" data-testid="saveLevel" [disabled]="!canSave">
        <i class="pi pi-save margin-fit"></i>
        <span>{{ 'challenge.save' | translate }}</span>
      </button>
    </div>
  </div>

<!-- form di inserimento -->
<div class="ui-g-12 vertical-margin-10 no-lateral-padding " [ngClass]="{ 'readonly-container': readOnly }">
  <div class="ui-g">

    <div class="ui-g-6">

      <!-- DESCRIPTION -->
      <div class="ui-g">
        <div class="ui-g-12">
          <app-form-fields #descriptionFields data-testid="descriptionField"
            [(fieldModel)]="fieldModel.description" [type]="'string'"
            [label]="'challenge.description' | translate" [name]="'description'"
            [optionLabel]="'description'" [placeholder]="'challenge.enter_description' | translate"
            [required]="true">
          </app-form-fields>
        </div>
      </div>

      <!-- PUSH NOTIFY -->
      <div class="ui-g">
        <div class="ui-g-4">
          <div class="label-switch" style="margin-bottom:20px">{{ 'challenge.pushNotify' | translate }}</div>
          <app-form-fields #pushNotify data-testid="pushNotifyField" [type]="'switch'"
            [(fieldModel)]="fieldModel.pushNotify" [required]="false"
            (fieldModelChange)="onPushNotifyChange($event)">
          </app-form-fields>
        </div>

        <div class="ui-g-8">
          <app-form-fields #pushNotifyText data-testid="pushNotifyTextField"
            [(fieldModel)]="fieldModel.pushNotifyText" [type]="'string'"
            [label]="'challenge.pushNotifyText' | translate" [name]="'pushNotifyText'"
            [placeholder]="'challenge.pushNotifyText' | translate"
            [disabled]="!fieldModel.pushNotify" [required]="fieldModel.pushNotify">
          </app-form-fields>
        </div>
      </div>
<!-- DESCR COMPLETE -->
<div class="ui-g">
  <div class="ui-g-12">
    <app-form-fields class="descrCompleteField" [(fieldModel)]="fieldModel.descrComplete" [type]="'textarea'"
      [label]="'challenge.descrComplete' | translate" [name]="'descrComplete'"
      [placeholder]="'challenge.descrComplete' | translate">
    </app-form-fields>

  </div>
      </div>

    </div>

   
    <div class="ui-g-6" *ngIf="showLevelsTable">
      <h3 class="title" style="margin-top: 0px;">{{ 'challenge.associatedLevels' | translate }}</h3>
    
      <p-table [value]="challengeDetailListElaborated" [paginator]="false" [rows]="100" class="levels-table"
        data-testid="levelsTable">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'challenge.level' | translate }}</th>
            <th>{{ 'challenge.acm' | translate }}</th>
            <th>{{ 'challenge.minimumThreshold' | translate }}</th>
            <th>{{ 'challenge.maxThreshold' | translate }}</th>
          </tr>
        </ng-template>
    
        <ng-template pTemplate="body" let-lvl>
          <tr>
            <td>{{ lvl.levelName }}</td>
            <td>{{ lvl.acmDescription }}</td>
            <td class="threshold">{{ lvl.minimumTrashold }}</td>
            <td class="threshold">{{ lvl.maximumTrashold }}</td>
         
          </tr>
        </ng-template>
    
      </p-table>
    </div>

  </div>
</div>


  <!-- bottone per aggiungere nuovo accumulatore -->
  <div class="ui-g-12 flexCenter">
    <div class="ui-g-3">
      <button class="btn-page-act" data-testid="addAccumulatorButton" style="margin-right: 10px;"
        (click)="onAddAccumulator()" *ngIf="!readOnly">
        <i class="pi pi-plus-circle margin-fit"></i>
        <span>{{ 'challenge.addAccumulator' | translate }}</span>
      </button>
    </div>
    <div class="ui-g-3"></div>
    <div class="ui-g-6"></div>
  </div>

  <!-- Titolo -->
  <h3 class="title">{{ 'challenge.accumulator' | translate }}</h3>

  <!-- lista degli accumulatori selezionati -->
  <div class="ui-g-12" *ngIf="fieldModel.linkedAcm.length > 0">
    <div *ngFor="let acm of fieldModel.linkedAcm; let i = index" class="ui-g-12 accumulator-item">
      <div class="accumulator-card"  [ngClass]="{ 'readonly-container': readOnly }">
        <div class="accumulator-info">

          <app-form-fields #channelDescription [(fieldModel)]="acm.acmDescription"
            [type]="'string'"
            [label]="'challenge.acmDescription' | translate"
            [name]="'channelDescription_' + i"
            [placeholder]="'challenge.enter_channel' | translate"
            [required]="true"
            [disabled]="true"
            [attr.data-testid]="'acmDescription-' + i">
          </app-form-fields>

          <app-form-fields #minThreshold [(fieldModel)]="acm.minThreshold"
            [type]="'number'"
            [label]="'challenge.minimumThreshold' | translate"
            [name]="'minThreshold_' + i"
            [placeholder]="'challenge.enter_minimumThreshold' | translate"
            [required]="true"
            [attr.data-testid]="'minThreshold-' + i">
          </app-form-fields>

          <app-form-fields #maxThreshold [(fieldModel)]="acm.maxThreshold"
            [type]="'number'"
            [label]="'challenge.maximumThreshold' | translate"
            [name]="'maxThreshold_' + i"
            [placeholder]="'challenge.enter_maximumThreshold' | translate"
            [required]="false"
            [attr.data-testid]="'maxThreshold-' + i">
          </app-form-fields>

        </div>

        <div class="accumulator-actions">
          <button class="remove-btn" (click)="removeAccumulatorACM(i)">&times;</button>
        </div>
      </div>

      <div class="field-error" *ngIf="acm.thresholdError">
        {{ acm.thresholdError }}
      </div>
    </div>
  </div>

  <!-- se non ci sono accumulatori -->
  <div class="ui-g-12" *ngIf="fieldModel.linkedAcm.length === 0">
    {{ 'challenge.no_acm_selected' | translate }}
  </div>

  <!-- modale per gli acm -->
  <p-dialog *ngIf="show.modalAcmList"
    [width]="1500"
    [height]="800"
    [(visible)]="show.modalAcmList"
    [responsive]="true"
    [header]="'challenge.search_accumulators' | translate"
    showEffect="fade"
    [modal]="true">

    <app-campaign-3-search-accumulators #searchAccumulators
      [accumulatorList]="listAccumulator"
      [multipleselection]="true"
      (acmSelected)="onAcmSelected($event)">
    </app-campaign-3-search-accumulators>

  </p-dialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/challenge/levels-creation/levels-creation.component.html